import axios from 'axios';

axios.interceptors.request.use(config => {
  const token = localStorage.token;
  config.headers.apiKey =  token;
  document.getElementById('loading_id').style.display="block";
  return config;
});
axios.interceptors.response.use(response => {
  document.getElementById('loading_id').style.display="none";
  return response;
}, (error) => {
  document.getElementById('loading_id').style.display="none";
  if (error && error.response && error.response.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/auth-pages/login';
  }
  return Promise.reject(error);
});

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export default axios;